<template>
  <v-container style="max-width: 1000px" >
    <v-card 
        max-width="1000"
        width="100%"
        elevation="8"
        rounded="0"
        class="pa-6"
      >
      <v-row>

        <v-col cols="6" md="6" class="d-flex flex-column justify-center">
          <v-img 
          max-height="100"
          class="hero-img" 
          :src="logo"/> 
        </v-col>
        <v-col cols="6" md="6">
          <v-img 
          max-height="100"
          class="hero-img" 
          :src="kuciak"/> 
        </v-col>
      </v-row>
   </v-card>
  <v-card class="info-card" flat rounded="0">
      <v-card-text style="padding: 1rem;">
          <div class="d-flex justify-space-between align-center mb-4">
            <h2 class="mb-0 font-weight-medium">Annual reports</h2>
            <router-link to="/about">
                <v-btn style="text-transform: none; " variant="text" class="mb-0 text-primary text-decoration-none">slovak</v-btn>
              </router-link>
          </div>
     
          <div class="year-buttons mb-6">
            <v-btn
              v-for="item in report"
              :key="item.year"
              class="year-ring"
              :class="{ active: Number(item.year) === latestYear }"
              :href="item.url"
              @click="selectedYear = item.year"
              target="_blank"
            >
              {{ item.year }}
            </v-btn>
          </div>
 
        <h2 class="mb-3 font-weight-medium">Accounting closures</h2>
          <v-btn 
            v-for="item in closure"
            :key="item.year"
            class="closer-button"
            :class="{ active: Number(item.year) === latestYear }"
            @click="selectedYear = item.year"
            :href="item.url"
            target="_blank"
            variant="text"
          >
            <v-icon size="12" class="text-primary pa-2">
              mdi-circle-outline
            </v-icon>
            {{ item.year }}
          </v-btn>
        

      <p><strong>
        The Investigative Center of Ján Kuciak (ICJK) was established as a not for profit civic organization in 2018, after the murder of Slovak investigative journalist Ján Kuciak and his fiancée Martina Kušnírová. The main goal of the ICJK is to continue in the legacy and work of Ján Kuciak. ICJK implements domestic and cross-border investigative projects, is involved in the protection of journalists in general and participates in the education of aspiring investigative journalists. ICJK was awarded by 
        Slovak National journalism prize for investigative reporting in five consecutive years 2020 - 2024 and one journalism prize for innovative journalism. 
        ICJK was also awarded by German Press Freedom prize by Medienverband der freien Presse in 2023.</strong></p>
      <p>
        Ján Kuciak and Martina Kušnírová were murdered on February 21, 2018. The murder was ordered to stop Ján's journalistic work. Ján Kuciak was the first Slovak investigative journalist who regularly collaborated with colleagues abroad, on projects such as Panama Papers. 
        <span class="text-primary">His last, unpublished article</span>, which was published in major world media after his murder, revealed the activities of the Calabrian 'Ndrangheta in eastern Slovakia and its connections to Slovak political elites.
        </p>

        <p><em>
        „Many times during the investigation of the Panama Papers, Jan mentioned what a great pity it is that we do not have the equivalent of the Czech Centre for Investigative Journalism in Slovakia. 
        A large number of our domestic cases spill over the borders, especially into tax havens. That is why I am very glad that the ICJK will continue Jan's work and uncover cases with an international dimension, 
        which could be fundamental. It's a pity that Jan didn't get to see it, he fought for the cooperation of journalists and he would have been very happy,"</em>Jozef Kuciak</p>
        <p>
          ICJK is an independent investigative center, only of its kind in Slovakia. The founding members of the ICJK are Ján Kuciak's colleagues and collaborators, investigative journalists: 
          the director of the <span class="text-primary">Stop Corruption Foundation</span> Zuzana Petková, 
          the director of the <span class="text-primary">Czech Centre for Investigative Journalism</span> Pavla Holcová, 
          and Slovak journalist and novelist Arpád Soltész.
        
        Since 2023 the Board of members consists of siblings of Jan Kuciak - Mária and Jozef, editor-in-chief of Aktuality.sk - newsroom for which Jan Kuciak worked - Peter Bárdy and Zuzana Petková. 
        Lukáš Diko has been the chairman of the civic association since 2021.</p>
        <p>
          <strong>Goals</strong> of the civic association based on its statutes:
        </p>

        <ul class="goals-list">
          <li>to provide a platform for investigative journalists,</li>
          <li>to coordinate cooperation between newrooms,</li>
          <li>to continue the legacy and work of investigative journalist Ján Kuciak,</li>
          <li>to protect human rights,</li>
          <li>to support education.</li>
        </ul>
        <p></p>
      <p>
        ICJK is a partner of the international organization <span class="text-primary">Organized Crime and Corruption Reporting Project (OCCRP)</span>, 
        which unites dozens of similar centers on four continents; and also of the international organization of investigative journalists, the <span class="text-primary">Global Investigative Journalism Network (GIJN)</span>. 
        ICJK is also partner of the European project <span class="text-primary">VSquare.org</span>, where we publish our investigation in English. Since 2026 ICJK became a member of the independent media initiative <span class="text-primary">Reference Circle</span> 
        and ICJK was elected as member of the board until 2027.
      </p>
      <p>
        In 2020, ICJK became the main Slovak center for international investigative cooperation with investigative journalists throughout Europe and overseas.
         As criminals and foreign influence operations has no borders, international cooperation in the investigations is irreplaceable. </p>
        <p>
        In Slovakia, we are trying to strengthen investigative journalism based on evidence and facts, which strengthens the rule of law by exposing organized crime, corruption, money laundering, and also helps to fight hoaxes and disinformation spread by foreign and domestic actors.</p>
         <p>
        We also try to uncover the illegal activities of Slovak citizens abroad. 
        We deal with corruption, money laundering, arms and narcotics trafficking, but also topics related to the environment and environmental crime. 
        We run the project ‘Kočner’s Library’, which contains large amounts of data, including information on possible crimes and connections of the convicted criminal Marian Kočner and other important persons suspected of crimes.</p>
        <p>We operate ICJK from grants and individual donations exclusively. There is no advertising or paid content on our website. All our incomes and expenses are published on our transparent bank account.</p>
        
        </v-card-text>
    </v-card>
        <v-card class="info-card" flat rounded="0">
          <v-card-text>
            <img :src="bezpecna" :style="{ 'max-width': smAndDown ? '120px' : '150px' }" class="mb-4" />
            <p>Safe.Journalism.sk initiative (Bezpečná.Žurnalistika.SK) was created because the safety of journalists is one of the most important challenges in Slovakia. Eight years after the murder of Ján and Martina, the number of attacks against journalists is not decreasing. On the contrary, it seems the trend is the opposite. </p>
            <p>
            Investigative Center of Ján Kuciak coordinates theinitiative in order to monitor the attacks against journalists and assist those facing the threat. The initiative is developed in cooperation with Reporters Without Borders, 
            the Embassy of the Kingdom of the Netherlands in Slovakia, and the Dutch system for protection of journalists, PersVeilig.
            </p>
          </v-card-text>
        </v-card>
        <v-card class="info-card" flat rounded="0">
          <v-card-text class="flex-grow-1">
            <div>
              <router-link to="/novinarske-ceny" class="red-ring-wins">
                <strong>Journalism <br>Prizes</strong>
              </router-link>
            </div>
          </v-card-text>
        </v-card>
        <v-card class="info-card" flat rounded="0">
            <v-card-text>
              <h2>Team ICJK</h2>
              
                <v-row>
                  <v-col
                    v-for="member in team"
                    :key="member.name"
                    cols="12"
                    sm="6"
                    md="4"
                  >
                    <h3 class="font-weight-regular">{{ member.name }}</h3>
                    <p>{{ member.role }}</p>
                  </v-col>
                </v-row>
            
              <p>If you would like to complete an internship at the Investigative Center of Ján Kuciak, please contact us.<br><strong>Contact: icjk@icjk.sk</strong></p>
          </v-card-text>
      </v-card>
  </v-container>
</template>

<script setup>
import kuciak from '@/assets/tvare.png'
import logo from '@/assets/logo2.png'
import bezpecna from '@/assets/logo-bezpecna-zurnalsitika.png'
import { ref, defineProps, computed } from 'vue'
import { useRoute } from 'vue-router'
import { useDisplay } from 'vuetify'

const { mdAndUp, smAndDown, name: breakpointName } = useDisplay()
const selectedYear = ref(2023)
const maxHeight = computed(() => {
  return (imageHeight[breakpointName.value] || 400)
})
// default language if not provided
const lang = ref('sk')
const props = defineProps({
  articleUID: String
})

const team = [
  { name: 'Lukáš Diko', role: 'editor-in-chief and editor' },
  { name: 'Karin Kőváry Sólymos', role: 'reporter' },
  { name: 'Tomáš Madleňák', role: 'reporter' },
  { name: 'Karolína Farská', role: 'journalist protection' },
  { name: 'Eva Štefanková', role: 'reporter' },
  { name: 'Karolína Kiripolská', role: 'reporter' }
]
const closure = [
  {year: '2024', url: 'https://www.registeruz.sk/cruz-public/domain/financialreport/show/9543478'},
  {year: '2023', url: 'https://www.registeruz.sk/cruz-public/domain/financialreport/show/8993814'},
  {year: '2022', url: 'https://www.registeruz.sk/cruz-public/domain/financialreport/show/8510758'}
]
const report = [
  {year:'2024', url: 'https://bezpecna.zurnalistika.sk/wp-content/uploads/2025/08/vyrocna-sprava-2024.pdf'},
  {year:'2023', url: 'https://bezpecna.zurnalistika.sk/wp-content/uploads/2024/08/vyrocna-sprava-2023.pdf'},
  {year:'2022', url: 'https://bezpecna.zurnalistika.sk/wp-content/uploads/2023/10/vyrocna-sprava-ICJK_2022.pdf'}
]



const latestYear = Math.max(...report.map(r => Number(r.year)))
const route = useRoute()

const imageHeight = {
  xs: 300,
  sm: 300,
  md: 400,
  lg: 400,
  xl: 500
}


</script>

<style scoped>
ul{
  list-style: none;
}

.year-buttons {
  display: flex;
  gap: 40px;
  justify-content: left;
}

.year-ring {
  width: 130px;
  height: 130px;
  border-radius: 50%;
  border: 10px solid #777;
  background: transparent;
  font-size: 32px;
  font-weight: 700;
  color: #777;
  cursor: pointer;
  transition: all 0.2s ease;
}
.year-ringAward {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  border: 12px solid #e53935;
  background: transparent;
  font-size: 32px;
  font-weight: 700;
  color: #e53935;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  position: relative;
  z-index: 1;
}


.year-ring.active {
  border-color: #e53935;
  color: #e53935;
}
.closer-button {
  color: #777;
}
.closer-button.active {
  border-color: #e53935;
  color: #e53935;
}

.year-ring:hover {
  transform: scale(1.05);
}
@media (max-width: 600px) {
  .year-ring {
    width: 85px;
    height: 85px;
    border-radius: 50%;
    border-width: 10px;
    font-size: 21px;
    border: 8px solid #777;
  }
}
.goals-list {
  list-style: none;
  padding-left: 0;
}

.goals-list li {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 6px;
  line-height: 1.2;
}

.goals-list li::before {
  content: "";
  width: 12px;
  height: 12px;
  border: 2px solid #e53935;
  border-radius: 50%;
  margin-top: 4px;
}

.red-ring-wins {
  width: 280px;
  height: 280px;
  border: 16px solid #e53935;
  border-radius: 50%;

  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 32px;
  text-align: center;

  text-decoration: none; /* odstráni link underline */
  color: inherit;

  cursor: pointer;
  transition: transform 0.6s ease;

  margin-left: auto;
  margin-right: auto;
}
.ring-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 320px;
}

.red-ring-wins:hover {
  transform: rotateY(360deg);
}
.info-card {
  margin: 60px 0;
  display: flex;
  flex-direction: column;
  box-shadow: #00000036 5px 5px 7px;
}

.info-card p {
  margin-bottom: 18px;
  line-height: 1.7;
}
.text-wrapper {
  max-width: 320px;
  margin-left: 130px;
}

.hero-title {
  font-size: 40px;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: -0.5px;
}
@media (max-width: 960px) {
  .text-wrapper {
    margin-left: 0;
  }

  .hero-title {
    font-size: 28px;
  }
}
.hero-img {
  height: 200px;
}

@media (min-width: 960px) {
  .hero-img {
    height: 100%;
    min-height: 300px;
  }
}
</style>

